import { Metadata, PaymentMethod } from "@stripe/stripe-js";
import { StripeProductPrice } from "../types/stripe";

export function getStripeProductPerksFromMetadata(
  productMetadata: Metadata
): string[] {
  const perks: string[] = [];
  for (let perk of Object.values(productMetadata)) {
    if (perk) perks.push(perk);
  }
  return perks;
} 

export function getPlanRecurringPeriod(
  stripePrice: StripeProductPrice
): 'mese' | 'anno' | 'semestre' {
  const interval = stripePrice.recurring?.interval;
  const interval_count = stripePrice.recurring?.interval_count;
  if (interval === 'year') return 'anno';
  if (interval_count === 1) return 'mese';
  return 'semestre';
}

export function extractStripePaymentMethodIdFromEvent(
  paymentMethod:  PaymentMethod | string | null
): string {
  if (!paymentMethod) throw "Invalid Pyament Method"
  if (typeof paymentMethod !== 'string') return paymentMethod.id;
  return paymentMethod;
}